/**
 * Created by Josef Jurca on 10/05/2017.
 */

import _ from 'lodash';

/**
 * Returns whether or not the response is valid.
 *
 * @param {Object} response - Response.
 * @returns {boolean} True or false.
 */
export function isValidResponse (response) {

    return !_.get(response, ['result', 'error']);
}


// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/validators/assets.js